import css from './test.module.scss';

import cx from 'classnames';
import { useLayoutEffect, useState } from 'react';

import { useImageViewer } from 'com/ImageViewer';
import { apiGetResource } from 'core/api';
import { useMessageModal } from 'core/ui/MessageModal';
import Preloader from 'core/ui/Preloader';

export function QuestionImage({ resourceUid }: { resourceUid: string }) {
  const [url, setUrl] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);
  const { showError } = useMessageModal();

  useLayoutEffect(() => {
    apiGetResource(resourceUid).then(setUrl).catch(showError);
  }, [resourceUid]);

  const imageViewer = useImageViewer();

  return (
    <div
      onClick={url ? () => imageViewer.show(url) : undefined}
      className={cx(css.imageWrapper, url && css.imageInteractive)}
    >
      {!url && <Preloader className={css.imagePreloader} />}
      {url && (
        <img
          className={css.image}
          src={url}
          crossOrigin="use-credentials"
          onLoad={() => setLoaded(true)}
          style={loaded ? undefined : { display: 'none' }}
          alt="Question"
        />
      )}
    </div>
  );
}
